<template>
  <div class="interaction-body display-minimum poll poll-display-minimum">
    <v-radio-group
      class="pt-0"
      hide-details
    >
      <div
        class="poll-option mb-1 pa-1 playposit-answer"
        :key="idx"
        v-for="(io, idx) in localInteraction.interactionOptions"
      >
        <v-layout
          align-center
        >
          <v-flex xs12>
            <v-radio
              class="mb-0"
              :ripple="false"
              readonly
            >
              <div
                class="mb-0 pp-interaction-body"
                slot="label"
                v-html="io.option"
              ></div>
            </v-radio>
            <InteractionAttachments :attachments="io.interactionOptionAttachments" />
          </v-flex>
        </v-layout>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'PollDisplayMinimumInteractionBody',
  components: {
    InteractionAttachments,
  },
  mixins: [
    Interaction,
  ],
};
</script>
